import styled from 'styled-components';

export const RadioButtonContainer = styled.div`
  padding: 0.75rem 1rem;
  max-height: 48px;
  display: flex;
  gap: 1rem;
  .hefesto-radiobutton {
    margin: 0;
    & > * .hefesto-radiobutton__slider--primary {
      border: 1px solid;
      border-color: ${({ theme }) => theme.colors.lightGray5};
    }
    :has(input:checked) {
      > * .hefesto-radiobutton__slider--primary {
        border-color: ${({ theme }) => theme.colors.blue6};
      }
    }
  }
`;
